import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export const ForWhoSection = () => {
  const paraVos = ['Te acostás cansado pero tu cabeza no para', 'Le das vueltas a problemas que no podés resolver de noche', 'Te despertás a mitad de la noche y no podés volverte a dormir', 'Sentís que cuanto más querés dormir, más despierto estás', 'Los pensamientos de "mañana voy a estar destruido" te empeoran todo', 'Llegás a la noche siempre pasado de vueltas', 'Ya probaste de todo y nada te funcionó de forma permanente', 'Querés una solución práctica, sin meditación ni espiritualidad', 'Estás entre los 20 y 40 años y el estrés del día a día te está comiendo el sueño'];
  const noParaVos = ['Tenés un trastorno de sueño diagnosticado que requiere tratamiento médico', 'Estás buscando una pastilla mágica que no requiera ningún esfuerzo', 'Querés algo espiritual o de autoayuda blanda', 'No estás dispuesto a aplicar lo que aprendés'];
  return <Section darker data-id="element-222">
      <div className="max-w-4xl mx-auto" data-id="element-223">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-224">
          <div className="bg-night-800/50 p-8 rounded-3xl border border-night-700" data-id="element-225">
            <h3 className="text-2xl font-bold text-white mb-8" data-id="element-226">
              Esto es exactamente para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-227">
              {paraVos.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-228">
                  <CheckCircle2 className="w-6 h-6 text-accent-blue shrink-0 mt-0.5" data-id="element-229" />
                  <span className="text-gray-300" data-id="element-230">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-night-900/50 p-8 rounded-3xl border border-night-800" data-id="element-231">
            <h3 className="text-2xl font-bold text-gray-400 mb-8" data-id="element-232">
              Esto NO es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-233">
              {noParaVos.map((item, idx) => <li key={idx} className="flex items-start gap-3 opacity-70" data-id="element-234">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-235" />
                  <span className="text-gray-400" data-id="element-236">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
};